export default (settings: any) => settings['columns'] * settings['languages'] * (1 / 60) * 10
